<template>
  <section class="eva-page">
    <v-row>
      <v-col
        cols="12"
        offset="0"
        md="10"
        offset-md="1"
      >
        <div class="eva-top">
          <v-breadcrumbs
            large
            :items="crumbs"
            divider="/"
            class="pl-0"
          />

          <div class="eva-title">
            <v-icon
              color="primary"
              class="mr-2"
            >
              mdi-file-document-plus-outline
            </v-icon>

            <span class="primary--text">
              Criar Formulário de Formação
            </span>
          </div>
        </div>

        <div class="mt-6">
          <Formulario
            :value="form"
            :loading="loading"
            title="Novo Formulário"
            submit-text="Criar formulário"
            @submit="createFormulario"
            @cancel="goBack"
          />
        </div>
      </v-col>
    </v-row>
  </section>
</template>

<script>
import Formacoes from "@/api/Formacoes.js";

import Formulario from "@/components/Formacoes/Formularios/Formulario.vue";

export default {
  name: "CreateFormulario",

  components: {
    Formulario,
  },

  beforeCreate() {
    document.title =
      "ODC - Criar Formulário de Formação";
  },

  data() {
    return {
      loading: false,

      form: {
        nome: "",
        codigo: "",
        descricao: "",
        is_active: true,
        campos: [],
      },
    };
  },

  computed: {
    crumbs() {
      return [
        {
          text: "Dashboard",
          disabled: false,
          to: "/admin",
          exact: true,
        },
        {
          text: "Formações",
          disabled: false,
          to: "/trainings",
          exact: true,
        },
        {
          text: "Formulários",
          disabled: false,
          to: "/trainings/forms",
          exact: true,
        },
        {
          text: "Criar",
          disabled: true,
        },
      ];
    },
  },

  mounted() {
    if (
      !this.$store.getters.hasPermission([
        "super",
        "trainings.forms.create",
      ])
    ) {
      this.$router.push(
        "/trainings"
      );
    }
  },

  methods: {
    createFormulario(payload) {
      if (this.loading) {
        return;
      }

      this.loading = true;

      Formacoes
        .createFormulario(payload)
        .then((response) => {
          const formulario =
            response.data;

          if (
            formulario
            && formulario.id
          ) {
            this.$router.push(
              "/trainings/forms/"
              + formulario.id
            );

            return;
          }

          this.$router.push(
            "/trainings/forms"
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },

    goBack() {
      this.$router.push(
        "/trainings/forms"
      );
    },
  },
};
</script>

<style scoped>
.eva-page {
  padding-bottom: 32px;
}

.eva-top {
  margin-top: 8px;
}

.eva-title {
  display: flex;
  align-items: center;
  font-size: 22px;
  font-weight: 800;
  letter-spacing: 0.2px;
}
</style>